<template>
  <div>
    <div v-if="isLoading" class="loading d-flex align-center justify-center">
      <div>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <!-- Don't have any group -->
      <div v-if="allTableData.has_groups == 0">
        <StandingHomeTable :standingData="standingData" :teamId="teamId" />
      </div>
      <!-- Have groups -->
      <div v-else>
        <!-- Group A -->
        <div v-if="group_a">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group A</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_a" :teamId="teamId" />
        </div>
        <!-- Group B -->
        <div v-if="group_b">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group B</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_b" :teamId="teamId" />
        </div>
        <!-- Group C -->
        <div v-if="group_c">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group C</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_c" :teamId="teamId" />
        </div>
        <!-- Group D -->
        <div v-if="group_d">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group D</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_d" :teamId="teamId" />
        </div>
        <!-- Group E -->
        <div v-if="group_e">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group E</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_e" :teamId="teamId" />
        </div>
        <!-- Group F -->
        <div v-if="group_f">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group F</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_f" :teamId="teamId" />
        </div>
        <!-- Group G -->
        <div v-if="group_g">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group G</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_g" :teamId="teamId" />
        </div>
        <!-- Group H -->
        <div v-if="group_h">
          <p class="mb-0 pt-1 pb-1 pl-3 font-weight-bold">Group H</p>
        </div>
        <div>
          <StandingHomeTable :standingData="group_h" :teamId="teamId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import StandingHomeTable from "@/components/common/StandingHomeTable.vue";
export default {
  components: {
    StandingHomeTable,
  },
  data() {
    return {
      isLoading: false,
      allTableData: [],
      standingData: [],
      group_a: [],
      group_b: [],
      group_c: [],
      group_d: [],
      group_e: [],
      group_f: [],
      group_g: [],
      group_h: [],
    };
  },
  props: {
    teamId: Number,
  },

  watch: {
    $route(to, from) {
      this.fetchData();
    },
  },
  methods: {
    ...mapActions(["Get_Standing_Content"]),
    fetchData() {
      this.isLoading = true;
      this.Get_Standing_Content(this.$store.state.seasonID)
        .then((data) => {
          this.allTableData = data;
          if (data.has_groups == 0) {
            let SortForstandingData = data.standings;
            this.standingData = SortForstandingData.sort(
              (a, b) =>
                parseFloat(a.home.position) - parseFloat(b.home.position)
            );
          } else {
            this.group_a = data.standings.group_a;
            this.group_b = data.standings.group_b;
            this.group_c = data.standings.group_c;
            this.group_d = data.standings.group_d;
            this.group_e = data.standings.group_e;
            this.group_f = data.standings.group_f;
            this.group_g = data.standings.group_g;
            this.group_h = data.standings.group_h;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.isLoading = false;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped lang="sass">
.loading
  min-height: 300px
  width: 100%
</style>
